import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { CITY_DIALOG_VISUAL_CLASS, CityDialogVisual, useProfileCityIsOther } from '@entities/user'
import { ProfileFocusField, profileFocusPath } from '@shared/config/routes'
import { ButtonVariant, ResultDialog } from '@shared/ui'
import {
  isProfileCityNoticeSeen,
  markProfileCityNoticeSeen,
  shouldShowProfileCityNotice,
} from '../model/profileCityNotice'

/**
 * Окно «Проверьте данные профиля» участнику с городом «Другое» (так бэк записал
 * города, введённые до обновления справочника). Закрывается только кнопками;
 * флаг вкладки не даёт ему вернуться при переходах и перезагрузке, новый визит
 * покажет его снова, пока город не выбран.
 */
export function ProfileCityNotice({ suspended }: { suspended: boolean }) {
  const { t } = useTranslation('participant')
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { profile, isOther } = useProfileCityIsOther()
  const [closed, setClosed] = useState(false)

  if (!profile) return null
  const open = shouldShowProfileCityNotice({
    isOtherCity: isOther,
    pathname,
    seen: closed || isProfileCityNoticeSeen(profile.id),
    suspended,
  })
  if (!open) return null

  const close = () => {
    markProfileCityNoticeSeen(profile.id)
    setClosed(true)
  }

  return (
    <ResultDialog
      open
      onOpenChange={() => undefined}
      dismissible={false}
      visual={<CityDialogVisual />}
      visualClassName={CITY_DIALOG_VISUAL_CLASS}
      title={t('profile_city_notice.title')}
      text={t('profile_city_notice.text')}
      actions={[
        { label: t('profile_city_notice.read'), onClick: close, variant: ButtonVariant.outline },
        {
          label: t('go_to_profile'),
          // Главное действие — на своём обычном месте, второй; фокус — на нём.
          autoFocus: true,
          onClick: () => {
            close()
            navigate(profileFocusPath(ProfileFocusField.city))
          },
        },
      ]}
    />
  )
}
